import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TagService } from '../tag.service';

@Component({
  selector: 'app-add-tag',
  templateUrl: './add-tag.component.html',
  styleUrls: ['./add-tag.component.scss']
})
export class AddTagComponent implements OnInit {
  model: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private tagService: TagService
  ) { }

  ngOnInit() {
  }


  onSubmit () {
    this.tagService.addTag(this.model).subscribe( Response => {
        this.router.navigateByUrl('/tags/tags');
      console.log('Tage added', Response);
    });
  }
}
